// @flow
import styled from 'styled-components';

export const PendingModerationBlock = styled.div`
  margin-bottom: 36px;
`;
